import {useEffect} from 'react';

import {getAdminDashboardDataACS, getManagerDashboardDataACS, setUserAC} from 'store/app/appSlice';
import {setManagedPubAC} from 'store/managedPub/managedPubSlice';
import {getManagedPubACS} from 'store/managedPub/requestAC';
import User from 'typescript/models/User';

import {useSetGlobalState} from './useSetGlobalState';

const useAppSetup = () => {
  const dispatch = useSetGlobalState();

  useEffect(() => {
    const stringifiedUser = localStorage.getItem('user');
    const stringifiedManagedPub = localStorage.getItem('managedPub');
    let parsedManagedPub;

    if (stringifiedUser) {
      const user: User = JSON.parse(stringifiedUser);

      dispatch(setUserAC(user));

      const hasPubs = user.attributes.pubs.length > 0;
      let firstPubId;

      if (user.attributes.pubs[0]) firstPubId = user.attributes.pubs[0].id;

      if (stringifiedManagedPub) {
        parsedManagedPub = JSON.parse(stringifiedManagedPub);
        dispatch(setManagedPubAC(parsedManagedPub));

        if (user.attributes.admin) {
          dispatch(getAdminDashboardDataACS());
        } else {
          dispatch(getManagerDashboardDataACS(parsedManagedPub.id));
        }
      } else if (hasPubs && firstPubId) {
        dispatch(getManagedPubACS(String(firstPubId)));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useAppSetup;
